export const coolGrey = {
  50: '#eff0f5',
  100: '#e3e5ef',
  200: '#d4d6e3',
  300: '#a3aabc',
  400: '#8e97ab',
  500: '#7a849c',
  600: '#6b758a',
  700: '#596173',
  800: '#494e5d',
  900: '#353945',
};
